export const SET_CONCEITO_ALUNO = 'SET_CONCEITO_ALUNO'
export const SET_CONCEITO_ALUNOS = 'SET_CONCEITO_ALUNOS'
export const UPDATE_CONCEITO_ALUNOS = 'UPDATE_CONCEITO_ALUNOS'
export const REMOVE_CONCEITO_ALUNOS = 'REMOVE_CONCEITO_ALUNOS'

